<template>
  <div id="basic">
    <div class="top_div">
      <el-form :inline="true" :model="formInline">
        <el-form-item label="请选择门店" style="margin-right: 20px">
          <el-select v-model="formInline.shop_id" placeholder="请选择">
            <el-option
              v-for="index in shopList"
              v-bind:key="index.id"
              :label="index.name"
              :value="index.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="外卖堂食">
          <el-select
            v-model="formInline.dish_type"
            placeholder="请选择"
            @change="changeCategoryType()"
          >
            <el-option label="全部" :value="0"></el-option>
            <el-option label="堂食" :value="1"></el-option>
            <el-option label="外卖" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <div class="demo-form-inline">
          <el-form-item label="按起止时间:">
            <el-date-picker
              v-model="formInline.date"
              type="daterange"
              :picker-options="pickerOptions"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              align="right"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="菜品分类">
            <el-select
              v-model="formInline.category_type"
              placeholder="请选择"
              @change="getCategoryLst"
            >
              <el-option label="全部" :value="0"></el-option>
              <el-option
                v-for="index in categoryLst"
                v-bind:key="index.id"
                :label="index.value"
                :value="index.key_name"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="菜品名称">
            <el-input v-model="formInline.dish_name"></el-input>
          </el-form-item>
        </div>

        <div class="bottom_center">
          <el-form-item style="min-width: 150px">
            <el-button
              type="primary"
              style="background: #1890ff"
              @click="() => getList()"
              >查询</el-button
            >
            <el-button type="primary" class="vubutton" @click="onSubmit"
              >重置</el-button
            >
          </el-form-item>
        </div>
      </el-form>
    </div>
    <el-row :gutter="20">
      <el-col :lg="12" :md="24"
        ><div class="grid-content purple_a">
          <div class="top_item_s">
            <div class="item_value_s">{{ totalPrice / 100 || 0 }}元</div>
            <div class="item_name_s">销售额</div>
            <!-- <div class="item_click_s">
              查看详细
              <i class="el-icon-caret-right"></i>
            </div> -->
          </div>
        </div>
      </el-col>
      <el-col :lg="12" :md="24"
        ><div class="grid-content purple_b">
          <div class="top_item_s">
            <div class="item_value_s">{{ (totalAmount / 1000).toFixed(2) || 0 }} kg</div>
            <div class="item_name_s">销售量</div>
            <!-- <div class="item_click_s">
              查看详细

              <i class="el-icon-caret-right"></i>
            </div> -->
          </div>
        </div>
      </el-col>
    </el-row>

    <el-row :gutter="20">
      <el-col :lg="12" :md="24">
        <div class="back">
          <el-table
            :fit="false"
            border
            :data="tableData"
            style="width: 100%"
            :cell-style="() => 'text-align: center;'"
            :header-cell-style="() => 'text-align: center;'"
          >
            <template slot="empty">
              <noCart style="width: auto"></noCart>
            </template>
            <el-table-column label="菜品名称" width="180">
              <template slot-scope="scope">
                <span>{{ scope.row.name }}</span>
              </template>
            </el-table-column>
            <el-table-column label="销售量" width="180">
              <template slot-scope="scope">
                <span>{{ (scope.row.total_amount / 1000).toFixed(2) }}kg</span>
              </template>
            </el-table-column>
            <el-table-column label="销售单价" width="180">
              <template slot-scope="scope">
                <span>{{ (scope.row.unit_price / 100).toFixed(2) }}元</span>
              </template>
            </el-table-column>

            <el-table-column label="总金额" width="180">
              <template slot-scope="scope">
                <span>{{ scope.row.total_price / 100 }}元</span>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            class="pagination"
            @current-change="changePage"
            background
            layout="prev, pager, next"
            :total="total"
            :page-size="page_size"
          ></el-pagination>
        </div>
      </el-col>
      <el-col :lg="12" :md="24">
        <div class="back" style="margin-bottom: 10px">
          <div class="topBox">
            <div class="titleColor">
              <i class="el-icon-s-marketing"></i> 菜品销量
            </div>
          </div>
          <div class="back_s" style="padding-bottom: 0px">
            <div
              id="echart_S"
              style="width: 100%; min-height: 500px; height: auto"
            ></div>
          </div>
        </div>
      </el-col>
    </el-row>

    <div style="height: 100px"></div>
  </div>
</template>

<script>
export default {
  name: 'management_dish',
  data() {
    return {
      formInline: {
        shop_id: '',
        category_type: 0, // 菜品分类
        date: null,
        dish_type: 0, // c_type|| 2外卖  1堂食
        dish_name: '', // 菜品名称
      },
      page_no: 1,
      page_size: 10,
      categoryLst: [],
      datalist: [],
      totalPrice: 0,
      totalAmount: 0,
      shopList: [],
      saleGraph: [],
      total: 0,
      tableData: [],
    };
  },
  created() {
    this.$root.headName = ['运营数据', '菜品销量'];
  },
  mounted() {
    this.getType();
    // this.getList();
    //
  },
  methods: {
    //获取门店
    getType() {
      const url = this.$userList.user_restaurant_list + `/0/999`;
      this.$http.get(url).then((res) => {
        if (res.code === 200) {
          this.shopList = res.data.items;
          this.formInline.shop_id = res.data.items[0].id;
          this.formInline.date = [this.fastDate(true), this.getDate(true)];
          this.getList();
          this.getCategoryLst();
        } else {
          res.message && this.$alert(res.message);
        }
      });
    },
    changeCategoryType(type) {},
    drawLines() {
      let elementById = document.getElementById('echart_S');
      let echartsDemo = this.$echarts.init(elementById);
      const option = {
        dataset: [
          {
            dimensions: ['name', 'total_amount', 'total_price'],
            source: this.saleGraph,
          },
          {
            transform: {
              type: 'sort',
              config: { dimension: 'total_price', order: 'asc' },
            },
          },
        ],
        xAxis: {
          max: 'dataMax',
        },
        yAxis: {
          type: 'category',
          axisLabel: { interval: 0, rotate: 30 },
        },
        series: {
          type: 'bar',
          encode: { x: 'total_price', y: 'name' },
          label: {
            show: true,
            precision: 1,
            position: 'right',
            valueAnimation: true,
            fontFamily: 'monospace',
          },
          datasetIndex: 1,
        },
      };
      echartsDemo.setOption(option);
    },
    changePage(index) {
      this.page_no = index;
      this.getList(true);
    },

    getDate(is) {
      var myDate = new Date();
      if (!is) {
        var tYear = myDate.getFullYear();
        var tMonth = myDate.getMonth();
        var m = tMonth + 1 < 10 ? '0' + (tMonth + 1) : tMonth + 1;
        return tYear + '-' + m;
      } else {
        var tYear = myDate.getFullYear();
        var tMonth = myDate.getMonth();
        var Dates =
          myDate.getDate() < 10 ? '0' + myDate.getDate() : myDate.getDate();
        var m = tMonth + 1 < 10 ? '0' + (tMonth + 1) : tMonth + 1;
        return tYear + '-' + m + '-' + Dates;
      }
    },
    fastDate(is) {
      var myDate = new Date(
        new Date().getTime() - 1000 * 60 * 60 * 24 * 31 * 12
      );
      if (!is) {
        var tYear = myDate.getFullYear();
        var tMonth = myDate.getMonth();
        var m = tMonth + 1 < 10 ? '0' + (tMonth + 1) : tMonth + 1;
        return tYear + '-' + m;
      } else {
        var tYear = myDate.getFullYear();
        var tMonth = myDate.getMonth();
        var Dates =
          myDate.getDate() < 10 ? '0' + myDate.getDate() : myDate.getDate();
        var m = tMonth + 1 < 10 ? '0' + (tMonth + 1) : tMonth + 1;
        return tYear + '-' + m + '-' + Dates;
      }
    },
    getList(isTablePage) {
      const shop_id = this.formInline.shop_id;
      let data = {};
      if (isTablePage) {
        data = {
          indicators: [
            {
              id: 2,
              shop_id,
              value_type: 'dish_sale',
              date_type: 'day',
              is_date_range: true,
              date_from: this.formInline.date[0],
              date_to: this.formInline.date[1],
              dish_type: this.formInline.dish_type,
              dish_category: this.formInline.category_type,
              page_size: this.page_size,
              page_no: this.page_no,
              dish_name: this.formInline.dish_name,
            },
          ],
        };
      } else {
        data = {
          indicators: [
            {
              id: 1,
              shop_id,
              value_type: 'dish_sale',
              date_type: 'day',
              is_date_range: true,
              date_from: this.formInline.date[0],
              date_to: this.formInline.date[1],
              dish_type: this.formInline.dish_type,
              dish_category: this.formInline.category_type,
              dish_name: this.formInline.dish_name,
            },
            {
              id: 2,
              shop_id,
              value_type: 'dish_sale',
              date_type: 'day',
              is_date_range: true,
              date_from: this.formInline.date[0],
              date_to: this.formInline.date[1],
              dish_type: this.formInline.dish_type,
              dish_category: this.formInline.category_type,
              page_size: this.page_size,
              page_no: this.page_no,
              dish_name: this.formInline.dish_name,
            },
            {
              id: 3,
              shop_id,
              value_type: 'dish_sale',
              date_type: 'day',
              is_date_range: true,
              date_from: this.formInline.date[0],
              date_to: this.formInline.date[1],
              dish_type: this.formInline.dish_type,
              dish_category: this.formInline.category_type,
              dish_name: this.formInline.dish_name,
              is_total: true,
            },
          ],
        };
      }
      console.log('================');
      console.log(data);
      const url = this.$userList.show_dish_indicator;
      this.$http.post(url, data).then((res) => {
        if (res.code === 200) {
          this.datalist = res.data.results;
          this.setDatalist();
        }
      });
    },
    // 获取菜品列表
    getCategoryLst() {
      let data = {
        parent_id: 0,
        shop_id: this.formInline.shop_id,
        menu_id: 0,
        category_type: this.formInline.category_type,
      };

      let baseUrl = this.$userList.user_menu_cuisines;
      const url = baseUrl + '/' + this.page_no + '/10';
      this.$http.get(url, data).then((res) => {
        if (res.code === 200) {
          this.categoryLst = res.data.items.map((item) => {
            console.log(item);
            return {
              id: item.id,
              key_name: item.id,
              value: item.name,
            };
          });
        } else {
          res.message && this.$alert(res.message);
        }
      });
    },

    setDatalist() {
      this.datalist.map((item) => {
        if (item.dish_indicator.id == 1) {
          this.saleGraph = [];
          item.value.map((v) => {
            this.saleGraph.push([
              v.name,
              v.total_amount / 1000,
              v.total_price / 100,
            ]);
          });
          this.drawLines();
        } else if (item.dish_indicator.id == 2) {
          this.total = item.value.count;
          this.tableData = item.value.items;
        } else {
          this.totalPrice = item.value[0].total_price;
          this.totalAmount = item.value[0].total_amount;
        }
      });
    },
    // getDateTop() {
    //   this.getList();
    // },
  },
};

/*
  import * as echarts from 'echarts';

  var chartDom = document.getElementById('main');
  var myChart = echarts.init(chartDom);
  var option;

  option = {
    dataset: [
      {
        dimensions: ['name', 'age', 'profession', 'score', 'date'],
        source: [
          ['Hannah Krause', 41, 'Engineer', 314, '2011-02-12'],
          ['Zhao Qian', 20, 'Teacher', 351, '2011-03-01'],
          ['Jasmin Krause ', 52, 'Musician', 287, '2011-02-14'],
          ['Li Lei', 37, 'Teacher', 219, '2011-02-18'],
          ['Karle Neumann', 25, 'Engineer', 253, '2011-04-02'],
          ['Adrian Groß', 19, 'Teacher', '-', '2011-01-16'],
          ['Mia Neumann', 71, 'Engineer', 165, '2011-03-19'],
          ['Böhm Fuchs', 36, 'Musician', 318, '2011-02-24'],
          ['Han Meimei', 67, 'Engineer', 366, '2011-03-12']
        ]
      },
      {
        transform: {
          type: 'sort',
          config: { dimension: 'score', order: 'asc' }
        }
      }
    ],
    xAxis: {
      max: 'dataMax'
    },
    yAxis: {
      type: 'category',
      axisLabel: { interval: 0, rotate: 30 }
    },
    series: {
      type: 'bar',
      encode: { x: 'score', y: 'name' },
      label: {
        show: true,
        precision: 1,
        position: 'right',
        valueAnimation: true,
        fontFamily: 'monospace'
      },
      datasetIndex: 1
    }
  };

  option && myChart.setOption(option);

*/
</script>

<style scoped>
.top_div {
  width: 100%;
  height: auto;
  box-sizing: border-box;
  padding: 20px;
  background: #fff;
}

.topBox {
  display: flex;
  justify-content: space-between;
  font-size: 18px;
  .titleColor {
    color: #f74608;
  }
  .onTitleColor {
    color: #0b74b8;
  }
  .perCapita {
    padding: 0 15px;
    font-size: 14px;
    color: #0b74b8;
    border-bottom: 1px solid #0b74b8;
  }
}

/deep/ .el-table__empty-block {
  width: auto !important;
}
.el-row {
  margin-bottom: 20px;
}
.el-row :last-child {
  margin-bottom: 0;
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #fff;
}
.back {
  width: 100%;
  box-shadow: 0 0 0px rgba(0, 0, 0, 0.295);
  box-sizing: border-box;
  background: #fff;
  padding: 0 10px;
  border-radius: 5px;
}
.back_s {
  width: 100%;
  box-sizing: border-box;
  background: #fff;
  padding: 0px 10px;
}
.back_s_name {
  font-size: 16px;
  width: 100%;
  text-align: center;
  line-height: 20px;
  font-weight: 600;
  margin-bottom: 20px;
}
.flex_center {
  margin-bottom: 10px;
}
.name_flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
}
.bg-purple-light {
  background: #e5e9f2;
}
.purple_a {
  background: #17a2b7;
}
.purple_b {
  background: #27a844;
}
.purple_c {
  background: #fec107;
}
.purple_d {
  background: #dc3546;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
  margin-bottom: 10px !important;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fcfa;
}
.top_item_s {
  box-sizing: border-box;
  padding: 10px 10px;
  height: 150px;
  color: #fff;
  position: relative;
}
.item_click_s {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 30px;
  color: #fff;
  text-align: center;
  line-height: 30px;
  background: rgba(0, 0, 0, 0.1);
  font-size: 12px;
}
.item_value_s {
  font-size: 30px;
  line-height: 36px;
  font-weight: 600;
  width: 100%;
  text-align: left;
}
.item_name_s {
  font-size: 16px;
  width: 100%;
  text-align: left;
  margin-top: 10px;
}
.istopflex {
  justify-content: space-between;
  align-items: center;
  display: flex;
}
.shujuflex {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.shujuflex_a {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: #26a345;
  display: none;
}
.shujuflex_b {
  font-size: 14px;
  line-height: 25px;
}
.shujuflex_c {
  font-size: 14px;
  line-height: 25px;
}
.shujuflex_page {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  padding: 20px 0;
}
.right_valur {
  width: 100%;
  height: 90px;
  margin-bottom: 10px;
  background: #fec107;
  display: flex;
  font-size: 16px;
  color: #fff;
  box-sizing: border-box;
  padding: 0 20px;
  line-height: 20px;
  align-items: center;
}
.leftIcon {
  font-size: 30px;
}
.right_valur_name {
  margin-left: 10px;
}
</style>
